import { useReducer } from 'react'
// helpers
const initial = {
  open: false,
  selectedUser: '',
  page: 1,
  dirtyBit: false,
  searchInput: '',
  filterSelected: null,
  type: null,
  transactionsData: []
}
const reducer = (state, action) => {
  const actions = {
    setPage: page => ({ ...state, page, dirtyBit: true }),
    setSearchInput: searchInput => ({
      ...state,
      searchInput,
      page: 1,
      dirtyBit: true
    }),
    setDirtyBit: dirtyBit => ({ ...state, dirtyBit }),
    setFilterSelected: filterSelected => ({
      ...state,
      filterSelected,
      page: 1
    }),
    setTransactionData: transactionsData => ({
      ...state,
      transactionsData,
      dirtyBit: false
    }),
    setSelectedUser: selectedUser => ({
      ...state,
      selectedUser
    }),
    setOpen: open => ({ ...state, open }),
    setValues: val => ({ ...state, ...val })
  }
  return actions[action.type]?.(action.val)
}
const useCreateStore = () => {
  const [states, dispatch] = useReducer(reducer, initial)
  const actions = {
    onOpen: (val = null) =>
      dispatch({ type: 'setValues', val: { open: true, type: val } }),
    onClose: () =>
      dispatch({ type: 'setValues', val: { open: false, type: null } }),
    setPage: val => dispatch({ type: 'setPage', val }),
    setDirtyBit: val => dispatch({ type: 'setDirtyBit', val }),
    setSearchInput: val => dispatch({ type: 'setSearchInput', val }),
    setFilterSelected: val => dispatch({ type: 'setFilterSelected', val }),
    setTransactionData: val => dispatch({ type: 'setTransactionData', val }),
    setSelectedUser: val => dispatch({ type: 'setSelectedUser', val })
  }
  return [states, actions]
}
export default useCreateStore
